const fieldHelpers = {
	Map: {
		name: "Map",
		component: "area-selector",
		props: {
			onSelect: "onSelect({selection})"
		},
		resolve: lookup => ({
			lookup
		})
	},
	MapPoint: {
		name: "MapPoint",
		component: "location-selector",
		props: {
			onSelect: "onSelect({selection})"
		},
		resolve: lookup => ({
			lookup
		})
	},
	MapWithoutBoundary: {
		name: "MapWithoutBoundary",
		component: "location-selector",
		props: {
			onSelect: "onSelect({selection})"
		},
		resolve: lookup => ({
			lookup
		})
	},
	NotAvailable: {
		name: "NotAvailable",
		component: "not-available",
		props: {
			onSelect: "onSelect({selection})"
		},
		resolve: lookup => ({
			lookup
		})
	},
	AdvancedSearch: {
		name: "AdvancedSearch",
		component: "advanced-search",
		props: {
			onSelect: "onSelect({selection})"
		},
		resolve: lookup => ({
			lookup
		})
	},
	CustomInput: {
		name: "CustomInput",
		component: "custom-input",
		props: {
			onSelect: "onSelect({selection})"
		},
		resolve: lookup => ({
			lookup
		})
	}

};

export default fieldHelpers;
